import { DEVICE_TYPES } from './constant';

export function getDeviceInfo(deviceModel: string) {
  if (!deviceModel) {
    return { deviceName: 'Unknown', osVersion: 'Unknown' };
  }
  const deviceType = deviceModel.split(' ', 1)[0];
  const deviceName = DEVICE_TYPES[deviceType];
  const osVersion = deviceModel.replace(deviceType, '').trim();
  return { deviceName, osVersion };
}
